import {
  getTraceTransportType,
  snapToTraceTransportType,
} from "@/utils/trace-utils";
import { McpDetailsSection } from "../McpDetailsSection";
import type { EnhancedTrace } from "../types";
import { GenericDetailsSection } from "./GenericDetailsSection";

interface TraceDetailsSectionProps {
  trace: EnhancedTrace;
}

export function TraceDetailsSection({ trace }: TraceDetailsSectionProps) {
  const transportType = getTraceTransportType(trace);
  const rootSpan = trace.spans?.find((span) => span.isRootSpan);
  const safeTransportType = snapToTraceTransportType(transportType);

  if (!rootSpan) {
    return null;
  }

  return (
    <div className="space-y-4">
      {/* Transport-specific content */}
      {safeTransportType === "http-rpc" ? (
        <McpDetailsSection span={rootSpan} />
      ) : (
        <GenericDetailsSection span={rootSpan} />
      )}
    </div>
  );
}

export { CloudflareInfoSection } from "../McpDetailsSection/CloudflareInfoSection";
export { GenericDetailsSection } from "./GenericDetailsSection";
